import { css } from '@emotion/css';

export const applicationPageCx = css`
  display: flex;
  align-items: center;

  > * {
    max-width: 34.375rem;
    width: 100%;
  }

  > header {
    left: 50%;
    transform: translateX(-50%);
  }
`;

export const applicationPageContentCx = css`
  height: 100%;
  max-height: 100%;

  .step {
    background-color: white;
    z-index: 1;
  }

  form {
    display: flex;
    flex-direction: column;
    height: 100%;
    max-height: 100%;

    overflow-y: auto;

    background-color: #f5f5f5;

    .application-card {
      &:not(:last-of-type) {
        margin-bottom: 0.5rem;
      }

      > .field-group:not(:last-of-type) {
        margin-bottom: 1rem;
      }
    }

    .field-group {
      scroll-margin-top: calc(var(--header-height) + 1rem);
    }

    .row-field {
      display: flex;
      .field-group {
        &:not(:last-child) {
          margin-right: 1rem;
        }
        flex: 1;
      }
    }
  }
`;
